export const ICON_TEST_ID = 'payment-method-icon';
export const ICON_WIDTH = 48;
export const ICON_HEIGHT = 32;

// we want to reduce the size of the payments icons in the footer when we have more than 6 icons
export const SMALL_ICON_WIDTH = 40;
export const SMALL_ICON_HEIGHT = 26;
